import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const downloadFile = (path: string, fileName?: string) => {
  const link = document.createElement('a');
  link.href = path;
  link.target = '_blank';
  if (fileName) link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const capitalize = (str: string | undefined) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getFileUrl = (fileMetadataId: string) => {
  if (!process.env.REACT_APP_BACKEND_URL) {
    throw new Error('REACT_APP_BACKEND_URL is not defined in the environment variables.');
  }

  return `${process.env.REACT_APP_BACKEND_URL}/admin/files/${fileMetadataId}`;
};
